import React from "react";
import { Box, Flex, Text, Stack, Divider } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";

const ViewPackagePlanDrawer = ({ isOpen, onClose, plan }) => {
  if (!plan) return null;

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<Text fontSize="2xl" fontWeight="bold">Package Plan Details</Text>}
      bodyContent={
        <Flex direction="column" p={6} width="100%">
          <Stack spacing={4}>
            <Box>
              <Text fontWeight="bold" color="gray.600" fontSize="sm">Name</Text>
              <Text fontSize="md">{plan.name}</Text>
            </Box>

            <Box>
              <Text fontWeight="bold" color="gray.600" fontSize="sm">Deliveries</Text>
              <Text fontSize="md">{plan.deliveries}</Text>
            </Box>

            <Box>
              <Text fontWeight="bold" color="gray.600" fontSize="sm">Price</Text>
              <Text fontSize="md">P{plan.price}</Text>
            </Box>

            <Box>
              <Text fontWeight="bold" color="gray.600" fontSize="sm">Expiry Days</Text>
              <Text fontSize="md">{plan.expiry_days}</Text>
            </Box>

            {plan.description && (
              <>
                <Divider />
                <Box>
                  <Text fontWeight="bold" color="gray.600" fontSize="sm">Description</Text>
                  <Text fontSize="md">{plan.description}</Text>
                </Box>
              </>
            )}
          </Stack>
        </Flex>
      }
    />
  );
};

export default ViewPackagePlanDrawer;
